/**
 * AppMet - Variante de la app para el cliente MET Energía.
 *
 * Reusa el AuthContext compartido (que ya devuelve credenciales MET
 * cuando TENANT === 'met') y monta sus propias rutas, theme y
 * componentes con la imagen corporativa MET.
 *
 * El Router usa `basename={TENANT_BASENAME}` (= '/met') así las
 * rutas internas (`/`, `/analizar`, `/generar-propuesta`) se
 * sirven bajo `/met/...` en producción.
 */

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';

import metTheme from './theme/theme';
import { AuthProvider } from '../context/AuthContext';
import { TENANT_BASENAME } from '../config/tenant';

import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';

import Login from './pages/Login';
import Home from './pages/Home';
import Analizar from './pages/Analizar';
import GenerarPropuesta from './pages/GenerarPropuesta';

function AppMet() {
  useEffect(() => {
    document.title = 'MET Energía - Licitator';
  }, []);

  return (
    <ThemeProvider theme={metTheme}>
      <CssBaseline />
      <Router basename={TENANT_BASENAME}>
        <AuthProvider>
          <Box
            sx={{
              minHeight: '100vh',
              backgroundColor: metTheme.palette.background.default,
            }}
          >
            <Header />
            <Box sx={{ py: 4 }}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/analizar"
                  element={
                    <ProtectedRoute>
                      <Analizar />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/generar-propuesta"
                  element={
                    <ProtectedRoute>
                      <GenerarPropuesta />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </Box>
          </Box>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default AppMet;
